import { Provider } from '@angular/core';
import {
  DictionaryEntry,
  DYNAMIC_CONFIG_TOKEN,
} from 'libs/platform/dynamic-components/src/lib/services/config-fetchers/fetch-config-from-code.service';

import { bestseller } from './bestseller';

const bestsellerConfigs: DictionaryEntry[] = [
  [
    'bestseller:added-to-basket-notification',
    [bestseller.addedToBasketNotification],
  ],
  ['bestseller:checkout', [bestseller.checkout]],
  [
    'bestseller:horizontal-scrollable-panel-best-performing-articles',
    [bestseller.horizontalScrollablePanekBestPerformingArticles],
  ],
  [
    'bestseller:horizontal-scrollable-panel-bought-this-season',
    bestseller.horizontalScrollablePanelBoughtThisSeason,
  ],
  [
    'bestseller:horizontal-scrollable-panel-bought-this-season-landing-page',
    bestseller.horizontalScrollablePanelBoughtThisSeasonLandingPage,
  ],
  [
    'bestseller:square-panel-best-performing-articles',
    bestseller.squarePanelFromRecommendationsBestPerformingArticles,
  ],
  [
    'bestseller:square-panel-products-on-the-way',
    bestseller.squarePanelFromRecommendationsProductsOnTheWay,
  ],
  [
    'bestseller:horizontal-scrollable-panel-re-stock',
    bestseller.horizontalScrollablePanelReStock,
  ],
];

export const bestsellerConfigsInjectionTokenProvider: Provider = {
  provide: DYNAMIC_CONFIG_TOKEN,
  useValue: bestsellerConfigs,
  multi: true,
};
